import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract, transformOptionalString } from '../../lib';
import { OrganizationDtoSchema } from '../contracts';

const CreateOrganizationWithUserRequestDtoSchema = z.object({
  email: z.email(),
  fullName: z.string(),
  address: z.string().optional().transform(transformOptionalString),
  name: z.string().optional().transform(transformOptionalString),
  siteUrl: z.string().optional().transform(transformOptionalString),
  isDemoUser: z.boolean().optional(),
});

const CreateOrganizationWithUserResponseDtoSchema = OrganizationDtoSchema;

export type CreateOrganizationWithUserRequestDto = z.infer<
  typeof CreateOrganizationWithUserRequestDtoSchema
>;
export type CreateOrganizationWithUserResponseDto = z.infer<
  typeof CreateOrganizationWithUserResponseDtoSchema
>;

export const createOrganizationWithUser = (
  dto: CreateOrganizationWithUserRequestDto,
  config?: AxiosRequestConfig<CreateOrganizationWithUserRequestDto>
) => {
  const data = CreateOrganizationWithUserRequestDtoSchema.parse(dto);
  return api
    .post('/organizations', data, config)
    .then(responseContract(CreateOrganizationWithUserResponseDtoSchema));
};
